export const handleChangeDataModalSuccessMsg = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_SUCCESS_MSG', name, value
});